"use client"

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { useAuthUI } from "@/contexts/AuthUIContext"
import { useRouter } from "next/navigation"
import { useState } from "react"
import { ReportIssueModal } from "@/components/dashboard/shared/report-issue-modal"

export function LoginFailureModal() {
    const { failedAttempts, resetFailedAttempts } = useAuthUI()
    const router = useRouter()
    const [isReportOpen, setIsReportOpen] = useState(false)

    const isOpen = failedAttempts >= 2

    const handleClose = () => {
        resetFailedAttempts()
    }

    return (
        <>
            <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
                <DialogContent className="sm:max-w-[425px]">
                    <DialogHeader>
                        <DialogTitle>Having trouble logging in?</DialogTitle>
                        <DialogDescription>
                            We noticed you're having difficulty accessing your account. How can we help?
                        </DialogDescription>
                    </DialogHeader>
                    <div className="flex flex-col gap-3 py-4">
                        <Button
                            onClick={() => {
                                handleClose()
                                router.push("/forgot-password")
                            }}
                            className="w-full"
                        >
                            Reset Password
                        </Button>
                        <Button
                            variant="outline"
                            onClick={() => {
                                handleClose() // Reset attempts
                                setIsReportOpen(true) // Open report modal
                            }}
                            className="w-full"
                        >
                            Report an Issue
                        </Button>
                    </div>
                    <DialogFooter>
                        <Button variant="ghost" onClick={handleClose} size="sm">
                            I'll try again
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            <ReportIssueModal
                isOpen={isReportOpen}
                onClose={() => setIsReportOpen(false)}
            />
        </>
    )
}
